import React from 'react';
import { Box, SpaceBetween } from '@cloudscape-design/components';

/**
 * Raw buyer-event Log — the textual companion to the Request-Flow diagram. Both
 * render from the same event stream. Each row is icon + colored text by kind.
 */
const KIND_META = {
  reasoning: { icon: '💭', color: '#5f6b7a' },
  request: { icon: '🌐', color: '#0972d3' },
  payment: { icon: '🪙', color: '#8d6a00' },
  result: { icon: '✓', color: '#037f0c' },
  fallback: { icon: '⚠', color: '#d91515' },
  sellerLog: { icon: '🏪', color: '#5f6b7a' },
};

export default function EventLog({ events }) {
  if (!events || events.length === 0) {
    return (
      <Box color="text-body-secondary" textAlign="center" padding="m">
        Agent reasoning, requests, and payments stream here.
      </Box>
    );
  }
  return (
    <SpaceBetween size="xxs">
      {events.map((e, i) => {
        const meta = KIND_META[e.kind] || KIND_META.reasoning;
        return (
          <div key={e.id || i} style={{ display: 'flex', gap: 8, alignItems: 'baseline', fontSize: 13 }}>
            <span aria-hidden style={{ flex: '0 0 18px' }}>
              {meta.icon}
            </span>
            <span style={{ color: meta.color, lineHeight: 1.4 }}>{e.text}</span>
          </div>
        );
      })}
    </SpaceBetween>
  );
}
